import styled from "styled-components";
import { height, HeightProps, margin, MarginProps } from "styled-system";

const Line = styled.div<MarginProps & HeightProps>`
  border: 1px solid #e5e5e5;
  ${margin}
  ${height}
`;

export default Line;
